import React from 'react';
import {
  Navigation,
  LegacyMobileNavigationTrigger,
} from '@cultureamp/unified-navigation-ui';
import { propsDecoder } from 'ca-common/propsDecoder';
import { useIntercom } from '@cultureamp/frontend-services';
import { JsonDecoder as JD } from 'ts.data.json';

type TextDirection = 'ltr' | 'rtl';

type RawUnifiedNavigationAppProps = {
  textDirection: TextDirection;
  isAdminRoute: boolean;
  activeRouteId: string | null;
  accessedAccountId: string | null;
  accessedAccountName: string | null;
  env: string;
};

const unifiedNavigationAppPropsDecoder =
  JD.objectStrict<RawUnifiedNavigationAppProps>(
    {
      textDirection: JD.oneOf(
        [JD.isExactly('ltr'), JD.isExactly('rtl')],
        'textDirectionDecoder'
      ),
      isAdminRoute: JD.boolean,
      activeRouteId: JD.nullable(JD.string),
      accessedAccountId: JD.nullable(JD.string),
      accessedAccountName: JD.nullable(JD.string),
      env: JD.string,
    },
    'UnifiedNavigationAppPropsDecoder'
  );

export const UnifiedNavigationApp: React.FunctionComponent = (
  rawProps: any
) => {
  const props = propsDecoder(unifiedNavigationAppPropsDecoder, rawProps);
  const {
    textDirection,
    isAdminRoute,
    activeRouteId,
    accessedAccountId,
    accessedAccountName,
    env,
  } = props;

  // Using the deprecated environment prop with the value of 'testing'
  // to use the mocked development navigation with all menus in feature tests
  const environment = env === 'test' ? 'testing' : undefined;
  const { toggleIntercomLauncher } = useIntercom();

  return (
    <Navigation
      activeRouteId={activeRouteId || undefined}
      textDirection={textDirection}
      environment={environment}
      onHelpClick={() => toggleIntercomLauncher('showWidget')}
      variant={isAdminRoute ? 'admin' : 'default'}
      mobileNavigationTrigger={(trigger) => (
        <span className="legacy__navigaiton-trigger">
          <LegacyMobileNavigationTrigger onTrigger={trigger} />
        </span>
      )}
      accessedAccountId={accessedAccountId || undefined}
      accessedAccountName={accessedAccountName || undefined}
    />
  );
};

export default UnifiedNavigationApp;
